module.exports = __webpack_public_path__ + "static/media/sendButton.01406ff3.svg";